"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialCarouselSectionClasses = void 0;
var _mui = require("@ori-ui/mui");
const editorialCarouselSectionClasses = exports.editorialCarouselSectionClasses = (0, _mui.generateUtilityClasses)('EditorialCarouselSection', ['root', 'button', 'title', 'carousel', 'inner']);
